export default __webpack_public_path__ + "static/media/Beehaz_03_fixed_term.aa7be0a9.png";